module.exports = __webpack_public_path__ + "static/img/header_bg.223aaf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/third/header/header_bg.png
// module id = 4WRB
// module chunks = 4